import { GraphNode } from 'types/api/services/status'

export interface LoadTestNodeStatus {
  loadGeneratorId: string
  loadGeneratorName: string
  status: LoadTestStatus
  errorAt?: LoadTestType
}

export enum LoadTestStatus {
  Error = 'Error',
  Triggered = 'Triggered',
  Running = 'Running',
  Stopped = 'Stopped',
  NotStarted = 'Not Started',
  Halted = 'Halted'
}

export enum LoadTestType {
  Start = 'Start',
  Status = 'Status',
  Stop = 'Stop'
}

export interface LoadTestNodeDetails {
  id: string
  name: string
  triggerNode: GraphNode
  stopNode: GraphNode
  loadStatusNode: GraphNode
}
